import { z } from 'my-zod'
import { additionalRider, legacyAdditionalRider } from '../../customer-operations/riders'
import { customerWaiversModel } from './customer-waivers-model'

export const customerWaiversSubmit = customerWaiversModel
  .omit({
    hasVehicleUseHistory: true,
    serverLastModifiedDate: true
  })
  .augment({
    currentRiderId: z.string().uuid().nullish(),

    lastDeviceId: z.string().nullish(),

    isoLanguageCode: z.string().nullish(),

    driverLicenseBase64: z.string().nullish(),
    driverLicenseCountry: z.string().nullish(),
    driversLicenseFrontPic: z.string().nullish(),
    driversLicenseBackPic: z.string().nullish(),

    isEhs: z.boolean().nullish(),
    isGuest: z.boolean().nullish(),
    isClassicSigned: z.boolean().nullish(),

    signature: z.string().array().nullish().or(z.string().nullish()),
    signatures: z.string().array().nullish(),

    // new riders/participant interface
    additionalRiders: additionalRider.array().or(legacyAdditionalRider.array()).optional()
  })

export type customerWaiversSubmit = z.infer<typeof customerWaiversSubmit>
